import React from 'react';
import { TableHead, TableRow } from '@mui/material';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import { StyledTableCell } from './index.style';

const CustomTableHeader = ({ columns, showNumber, headerStyle }) => {
  const { t } = useTranslation();

  return (
    <TableHead style={headerStyle}>
      <TableRow>
        {showNumber && (
          <StyledTableCell className="header-cell" align="center">
            <Typography color={COLOR.darkGray} variant="body-14-medium">
              {t('no')}
            </Typography>
          </StyledTableCell>
        )}
        {columns.map((column) => (
          <StyledTableCell
            className="header-cell"
            key={column.field}
            align={column.align}
            width={column.width}
          >
            <div
              id={column.id}
              className={`header-item header-${column.align}`}
            >
              <Typography color={COLOR.darkGray} variant="body-14-medium">
                {column.title}
              </Typography>
            </div>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default CustomTableHeader;
